var _rect, _rect2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPeopleIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 19.5,
    height: 19.5,
    rx: 9.75,
    stroke: "#C6C4C4",
    strokeOpacity: 0.77,
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.875 7.75C7.875 6.57639 8.8264 5.625 10 5.625C11.1736 5.625 12.125 6.57639 12.125 7.75C12.125 8.9236 11.1736 9.875 10 9.875C8.8264 9.875 7.875 8.9236 7.875 7.75ZM10 6.375C9.24061 6.375 8.625 6.99061 8.625 7.75C8.625 8.50939 9.24061 9.125 10 9.125C10.7594 9.125 11.375 8.50939 11.375 7.75C11.375 6.99061 10.7594 6.375 10 6.375Z",
    fill: "#81827E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 11.375C7.37868 11.375 6.875 11.8787 6.875 12.5V13.0941C6.875 13.1032 6.88156 13.1109 6.89048 13.1124C8.94986 13.4486 11.0501 13.4486 13.1095 13.1124C13.1184 13.1109 13.125 13.1032 13.125 13.0941V12.5C13.125 11.8787 12.6213 11.375 12 11.375H11.8296C11.8164 11.375 11.8033 11.3771 11.7908 11.3812L11.358 11.5225C10.4756 11.8106 9.52441 11.8106 8.64199 11.5225L8.20923 11.3812C8.19671 11.3771 8.18361 11.375 8.17043 11.375H8ZM6.125 12.5C6.125 11.4645 6.96447 10.625 8 10.625H8.17043C8.26268 10.625 8.35435 10.6396 8.44204 10.6682L8.87479 10.8095C9.60594 11.0483 10.3941 11.0483 11.1252 10.8095L11.558 10.6682C11.6457 10.6396 11.7373 10.625 11.8296 10.625H12C13.0355 10.625 13.875 11.4645 13.875 12.5V13.0941C13.875 13.4708 13.6021 13.7919 13.2304 13.8526C11.091 14.2019 8.90905 14.2019 6.76964 13.8526C6.39794 13.7919 6.125 13.4708 6.125 13.0941V12.5Z",
    fill: "#81827E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleIcon2);
export default __webpack_public_path__ + "static/media/peopleIcon2.0452f61aff10e8233a1119002226c180.svg";
export { ForwardRef as ReactComponent };